(() => {
  const openCartFromHash = () => {
    if (window.location.hash !== "#open-cart") {
      return;
    }

    window.customElements.whenDefined("cart-drawer").then(() => {
      if (window.location.hash === "#open-cart") {
        const cartDrawer = document.getElementById("cart-drawer");

        if (cartDrawer) {
          cartDrawer.show();
          window.history.replaceState(
            window.history.state,
            "",
            `${window.location.pathname}${window.location.search}`,
          );
        }
      }
    });
  };

  openCartFromHash();
  window.addEventListener("hashchange", openCartFromHash);
  window.addEventListener("pagehide", () => {
    document.getElementById("cart-drawer")?.hide?.();
  });
})();
